// Import dependencies
import React from "react";

// Import motion library
import { motion } from "framer-motion";

// Import lottie components
import Gear from "../../Lotties/Gear";

// Import data content
import { content } from "../../assets/data/Content";

// Import styles
import "./Intro.css";

const Intro = () => {
  // Data content
  const { aboutMe } = content;

  return (
    <>
      <motion.div
        className="box__intro absolute left-[100%] top-[50%] w-[65vw] h-[55vh] flex z-[1]"
        initial={{ height: 0 }}
        animate={{ height: "55vh" }}
        transition={{ type: "spring", duration: 2, delay: 0 }}
      >
        {/* Textos */}
        <div className="w-[50%] relative flex">
          <div className="p-8 flex flex-col md:justify-evenly">
            <h1 className="font-Inria">Hola,</h1>

            <p className="mt-5">
              Soy Nicolás Santiago Naranjo, Desarrollador Web y te doy la
              bienvenida a mi portafolio.
            </p>
          </div>
        </div>

        <motion.div
          className="w-[50%] relative flex"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        >
          {/* Profile image */}
          <img
            src={aboutMe.image}
            alt="Foto Perfil"
            className="picture absolute bottom-3 md:bottom-[30%] lg:bottom-[6.5%] left-[50%] w-[100%] h-auto"
          />
        </motion.div>
      </motion.div>

      {/* Return */}
      <div className="absolute bottom-[5%] left-[100%] right-[0%] w-[90%] md:w-[100%] z-10 cursor-pointer">
        <Gear />
      </div>
    </>
  );
};

export default Intro;
